import SideBar from "../../components/SideBar";
import NavBar from "../../components/NavBar";
import Footer from "../../components/Footer";
import React, { useEffect, useState } from "react";
import { refreshEtatsSinistres, rejectEvaluation, validateEvaluation } from "../../hooks/useHooks";
import { Card, DatePicker, Dropdown, Menu, Modal, Row, Spin, Table, Tag } from "antd";
import { EllipsisOutlined, FileProtectOutlined } from "@ant-design/icons";
import { frenchDate } from "../../variables/functions";
import { toast } from "react-toastify";
import EvaluationDetailsModal from "./components/modals/EvaluationDetailsModal";
import axiosInstance from "../../variables/api/axiosInstance";
import "../../assets/styles/elt.css";
import { displayNumbers } from "../../variables/numbersFunctions";
import { highlightMatch } from "../../variables/stringFunctions";
import { searchSinistre } from "../../hooks/useSearch";
import { useNavigate } from "react-router-dom";
import { StatCard } from "../../components/statistics/StatCard";
import { SINISTER_COLORS } from "../../components/ui/colors";

const { confirm } = Modal

const { RangePicker } = DatePicker;

const ValidationEvaluations = () => {
    const [evaluations, setEvaluations] = useState([]);
    const [evaluationsLoading, setEvaluationsLoading] = useState(false);
    const [filteredEvaluations, setFilteredEvaluations] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [refetch, setRefetch] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [countEvaluations, setCountEvaluations] = useState({});
    const [searchResults, setSearchResults] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const navigate = useNavigate();

    const handleChange = (pagination, filters, sorter) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const fetchAllEvaluations = async (params = {}) => {
        setEvaluationsLoading(true);
        const response = await axiosInstance.get(`/api/evaluation/sinistre`, {
            params: {
                page: params.pagination.current - 1,
                size: params.pagination.pageSize,
                ...params.filters,
                compagnie: params.filters?.compagnie?.join(','),  // join the compagnies with `&compagnie=`
            },
        });

        const { content, totalElements } = response.data;
        setEvaluations(content);
        setFilteredEvaluations(content);
        setEvaluationsLoading(false);
        setPagination({
            ...params.pagination,
            total: totalElements,
        });
        setTotal(totalElements);
        console.log(refetch);
    };

    useEffect(() => {
        fetchAllEvaluations({ pagination, filteredInfo });

        axiosInstance.get(`/api/evaluation/statut-count`).then((res) => {
            setCountEvaluations(res.data);
        }).catch((error) => {
            console.error("Error fetching evaluation status counts:", error);
        });

    }, [currentPage, pageSize]);

    const [selectedDetailsOpen, setSelectedDetailsOpen] = useState(false)
    const [selectedDetails, setSelectedDetails] = useState({})
    const handleDetailsModal = (record) => {
        setSelectedDetailsOpen((prevState) => !prevState)
        const selectedEvaluation = evaluations?.filter((ev) => ev?.evaluation.codeId === record.key)[0]
        console.log(selectedEvaluation)
        setSelectedDetails(selectedEvaluation)
    }
    const handleDetailsClose = () => {
        setSelectedDetailsOpen(true)
        setSelectedDetails({})
    }
    const onlyEvaluations = evaluations?.map((ev) => ev?.evaluation);

    console.log(evaluations)

    const source = evaluations?.map((ev) => {
        const { sinistreNumSinistre, sinistreNumPolice, sinistreSouscripteur, evaluation, courant } = ev;
        const { codeId, ancienneProvision, nouvelleProvision, createdAt, etatEvaluation } = evaluation || {};

        if (!sinistreNumSinistre && !sinistreNumPolice && !sinistreSouscripteur && !ancienneProvision && !nouvelleProvision) {
            return null;
        }

        return {
            key: codeId,
            numSinistre: sinistreNumSinistre,
            numPolice: sinistreNumPolice,
            souscripteur: sinistreSouscripteur,
            ancienneProvision,
            nouvelleProvision,
            etatEvaluation,
            courant,
            dateEvaluation: frenchDate(createdAt)
        };
    }).filter(item => item !== null);

    const columns = [
        {
            title: 'Numero de sinistre',
            dataIndex: 'numSinistre',
            key: 'numSinistre',
        },
        {
            title: 'Numero de police',
            dataIndex: 'numPolice',
            key: 'numPolice',
        },
        {
            title: 'Souscripteur',
            dataIndex: 'souscripteur',
            key: 'souscripteur',
        },
        {
            title: 'Ancienne provision',
            dataIndex: 'ancienneProvision',
            key: 'ancienneProvision',
            render: (text) => {
                return <span>{displayNumbers(text)}</span>;
            }
        },
        {
            title: 'Nouvelle provision',
            dataIndex: 'nouvelleProvision',
            key: 'nouvelleProvision',
            render: (text) => {
                return <span>{displayNumbers(text)}</span>;
            }
        },
        {
            title: 'Etat',
            dataIndex: 'etatEvaluation',
            key: 'etatEvaluation',
            render: (etat) => {
                let color;
                switch (etat) {
                    case 'VALIDE':
                        color = 'green';
                        break;
                    case 'EN_ATTENTE':
                        color = 'blue';
                        break;
                    case 'REJETE':
                        color = 'red';
                        break;
                    default:
                        color = 'gray';
                }
                return <Tag color={color}>{etat}</Tag>;
            }
        },
        {
            title: 'Date de l\'evaluation',
            dataIndex: 'dateEvaluation',
            key: 'dateEvaluation',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                const menu = (
                    <Menu>
                        {record?.etatEvaluation === "VALIDE" ?
                            <Menu.Item key="rejeter" icon={<i className="bx bx-x"></i>}
                                onClick={() => handleRejeterEvaluation(record)}>
                                Rejeter
                            </Menu.Item>
                            :
                            <Menu.Item key="valider" icon={<i className="bx bx-check"></i>}
                                onClick={() => handleValiderEvaluation(record)}>
                                Valider
                            </Menu.Item>}
                        <Menu.Item key="details" onClick={() => handleDetailsModal(record)}
                            icon={<i className="bx bx-show"
                            ></i>}>
                            Voir les details
                        </Menu.Item>
                    </Menu>
                );

                return (
                    <Dropdown overlay={menu} trigger={["click"]}>
                        <EllipsisOutlined style={{ cursor: "pointer" }} />
                    </Dropdown>
                );
            },
        },
    ];

    const handleDateFilter = (dates) => {
        if (!dates) {
            setFilteredEvaluations(evaluations);
            return;
        }
        const [start, end] = dates.map(date => date.startOf('day').toDate());

        setFilteredEvaluations(
            evaluations.filter(ev => {
                const createdAt = ev?.evaluation?.createdAt;
                if (!createdAt) return false;
                const evaluationDate = new Date(createdAt);
                return evaluationDate >= start && evaluationDate <= end;
            })
        );
    };
    const confirmColumns = [
        {
            title: 'Numéro de sinistre',
            dataIndex: 'numSinistre',
            key: 'numSinistre',
        },
        {
            title: 'Numéro de police',
            dataIndex: 'numPolice',
            key: 'numPolice',
        },
        {
            title: 'Souscripteur',
            dataIndex: 'souscripteur',
            key: 'souscripteur',
        },
        {
            title: 'Nouvelle provision',
            dataIndex: 'nouvelleProvision',
            key: 'nouvelleProvision',
            render: (text) => {
                return <span>{displayNumbers(text)}</span>;
            }
        },
    ]

    const findEvaluationByCodeId = (codeId) => {
        return onlyEvaluations?.filter((ev) => ev?.codeId === codeId)[0]
    }

    const handleValiderEvaluation = (record) => {
        confirm({
            title: 'Voulez-vous vraiment valider cette évaluation ?',
            icon: <i className="bx bx-check-circle" style={{ color: 'green', fontSize: '24px' }}></i>,

            width: 800,
            content: (
                <div>
                    <Table
                        dataSource={[record]}
                        columns={confirmColumns}
                        pagination={false}
                        bordered
                    />
                </div>
            ),
            onOk() {
                try {
                    console.log('Évaluation validée:', record);
                    console.log(findEvaluationByCodeId(record.key))
                    const evaluation = findEvaluationByCodeId(record.key)
                    evaluation.etatEvaluation = 'VALIDE'
                    validateEvaluation(evaluation?.codeId)
                    setRefetch((prev) => !prev);
                    toast.success('Évaluation validée avec succès')
                } catch (e) {
                    console.log(e)
                    toast.error('Erreur lors de la validation de l\'évaluation')
                }
            },
            onCancel() {
                console.log('Validation annulée');
            },
        });
    };
    const handleRejeterEvaluation = (record) => {
        confirm({
            title: 'Voulez-vous vraiment rejeter cette évaluation ?',
            icon: <i className="bx bx-x-circle" style={{ color: 'darkred', fontSize: '24px' }}></i>,
            width: 800,
            content: (
                <div>
                    <Table
                        dataSource={[record]}
                        columns={confirmColumns}
                        pagination={false}
                        bordered
                    />
                </div>
            ),
            onOk() {
                try {
                    console.log('Évaluation rejetée:', record);
                    console.log(findEvaluationByCodeId(record.key))
                    const evaluation = findEvaluationByCodeId(record.key)
                    evaluation.etatEvaluation = 'REJETE'
                    rejectEvaluation(evaluation.codeId)
                    toast.success('Évaluation rejetée avec succès')
                    setRefetch((prev) => !prev);
                } catch (e) {
                    console.log(e)
                    toast.error('Erreur lors du rejet de l\'évaluation')
                } finally {
                    setRefetch(false)
                }
            },
            onCancel() {
                console.log('Validation annulée');
            },
        });
    };

    /**
     * Rafraichit les SAP et les évaluations.
     * Elle appelle d'abord la fonction `refreshEtatsSinistres` pour mettre à jour les SAP,
     * puis appelle la fonction `fetchAllEvaluations` pour mettre à jour les évaluations.
     * Si une erreur survient pendant l'appel à `refreshEtatsSinistres`, elle est consignée dans la console,
     * et la valeur de `evaluationsLoading` est remise à false.
     */
    const refreshSapAndEvaluations = () => {
        setEvaluationsLoading(true);
        const response = refreshEtatsSinistres().then(() => {
            setEvaluationsLoading(false);
            fetchAllEvaluations();
        }).catch((error) => {
            console.log(error);
            setEvaluationsLoading(false);
        });
    }

    const renderSearchResults = (results) => {
        return <div className="px-3 py-2">
            <h6 className="text-muted text-uppercase mb-2"></h6>
            {results.map((item, index) => (
                <div
                    key={index}
                    onClick={() =>
                        navigate("/details-sinistre", {
                            state: { codeId: item.codeId },
                        })
                    }
                    className="dropdown-item d-flex align-items-center gap-2 py-1"
                    style={{ cursor: "pointer" }}
                >
                    <span className="text-truncate">
                        {[
                            (item?.numeroSinistreM || item?.numeroSinistreP || item?.numSinistre),
                            item?.numeroPoliceM
                                ? item?.numeroPoliceM
                                : item?.numeroPoliceP,
                            frenchDate(item?.dateSinistre),
                            item?.immatriculation,
                            item?.nom,
                            item?.prenom || "",
                        ].map((text, i) => (
                            <React.Fragment key={i}>
                                {i > 0 && " - "}
                                {highlightMatch(text?.toString(), searchValue)}
                            </React.Fragment>
                        ))}
                    </span>
                </div>
            ))}
        </div>;
    }

    useEffect(() => {
        if (searchValue && searchValue?.length > 2) {
            searchSinistre(searchValue).then((res) => {
                setSearchResults(res.data.content);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, [searchValue]);

    return (
        <div className="layout-wrapper layout-content-navbar  ">
            <div className="layout-container">
                <SideBar currentMenu={"SINISTRES"} />
                {/* <!-- Layout container --> */}
                <div className="layout-page">
                    <NavBar
                        filteredResults={searchResults}
                        setFilteredResults={setSearchResults}
                        renderSearchResults={renderSearchResults}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />
                    {/* <!-- Content wrapper --> */}
                    <div className="content-wrapper">
                        {/* <!-- Content --> */}
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div
                                style={{
                                    minHeight: '100vh',
                                    backgroundColor: '#F9FBF9',
                                    padding: '24px'
                                }}
                            >
                                <div style={{ maxWidth: '1600px', margin: '0 auto' }}>
                                    {/* En-tête */}
                                    <div style={{
                                        marginBottom: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px'
                                    }}>
                                        <div style={{
                                            width: '56px',
                                            height: '56px',
                                            borderRadius: '14px',
                                            background: 'linear-gradient(135deg, #2ECC71 0%, #145A32 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 6px 20px rgba(46, 204, 113, 0.4)'
                                        }}>
                                            <FileProtectOutlined style={{ fontSize: '28px', color: 'white' }} />
                                        </div>
                                        <div>
                                            <h1 style={{
                                                margin: 0,
                                                fontSize: '32px',
                                                fontWeight: 700,
                                                color: '#333333'
                                            }}>
                                                Validation des évaluations
                                            </h1>
                                            <p style={{
                                                margin: 0,
                                                color: '#666',
                                                fontSize: '15px'
                                            }}>
                                                Gestion et validation des évaluations de sinistres
                                            </p>
                                        </div>
                                    </div>
                                    <Spin spinning={evaluationsLoading}>
                                        <Row style={{ marginBottom: "22px", justifyContent: "space-between" }}>
                                            <StatCard
                                                title="Evaluations validées"
                                                subtitle="Nombre total des évaluations validées"
                                                value={displayNumbers(countEvaluations?.valideCount) || 0}
                                                icon="bx bx-check-circle"
                                                iconBg={SINISTER_COLORS.primary}
                                                gradient={SINISTER_COLORS.primary}
                                            />
                                            <StatCard
                                                title="Evaluations en attente"
                                                subtitle="Nombre total des évaluations en attente"
                                                value={displayNumbers(countEvaluations?.attenteCount) || 0}
                                                icon="bx bxs-hourglass"
                                                iconBg={SINISTER_COLORS.primary}
                                                gradient={SINISTER_COLORS.primary}
                                            />
                                            <StatCard
                                                title="Evaluations rejetées"
                                                subtitle="Nombre total des évaluations rejetées"
                                                value={displayNumbers(countEvaluations?.rejeteCount) || 0}
                                                icon="bx bx-message-alt-x"
                                                iconBg={SINISTER_COLORS.primary}
                                                gradient={SINISTER_COLORS.primary}
                                            />
                                        </Row>
                                    </Spin>
                                    <Spin spinning={evaluationsLoading}>
                                        <Card
                                            bordered={false}
                                            style={{
                                                marginBottom: '4px',
                                                borderRadius: '12px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                            }}
                                        >
                                            <RangePicker onChange={handleDateFilter} style={{ marginBottom: '0px' }} />

                                        </Card>
                                        <Card
                                            bordered={false}
                                            style={{
                                                borderRadius: '12px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <Table
                                                dataSource={source}
                                                columns={columns}
                                                rowClassName={(record) => {
                                                    return record.courant ? 'highlight-row' : '';
                                                }}
                                                onChange={handleChange}
                                                pagination={{
                                                    current: currentPage,
                                                    pageSize: pageSize,
                                                    total: total,
                                                    showSizeChanger: true,
                                                }}
                                            />
                                        </Card>

                                    </Spin>
                                    {
                                        selectedDetails ? (
                                            <>
                                                <EvaluationDetailsModal
                                                    isVisible={selectedDetailsOpen}
                                                    onClose={() => setSelectedDetailsOpen(false)}
                                                    evaluationData={selectedDetails}
                                                />
                                            </>
                                        ) :
                                            null

                                    }


                                </div>
                            </div>

                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div className="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div className="layout-overlay layout-menu-toggle"></div>

            <Spin spinning={evaluationsLoading}>
                <div class="buy-now">
                    <button
                        onClick={() => refreshSapAndEvaluations()}
                        class="btn btn-secondary btn-buy-now"
                    >
                        Refresh SAP & Evaluations
                    </button>
                </div>
            </Spin>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div className="drag-target"></div>
        </div>
    );
};

export default ValidationEvaluations;
